<div class="main-container">
  <app-page-header></app-page-header>
</div>